<template>
    <div>
        <v-select :multiple="true" :options="optionsExhibiciones" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedExhibicioness" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "tipoExhibicion",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedExhibicioness:[],
            optionsExhibiciones:[]
        }
    },
    mounted() {
        this.getGestores();
    },
    methods:{
        getGestores(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/tipoExhibiciones',{tipo:0})
                .then(function (r){
                    $this.optionsExhibiciones = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioExhibiciones');
        }

    }
}
</script>

<style scoped>

</style>
